export default __webpack_public_path__ + "static/media/dropdown-down-arrow.0ee17d5f.svg";